import { render, staticRenderFns } from "./PollsResultsStandaloneColumn.vue?vue&type=template&id=1a6e6173&"
import script from "./PollsResultsStandaloneColumn.vue?vue&type=script&lang=js&"
export * from "./PollsResultsStandaloneColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports